<template>
  <header id="header">
    <div class="header-row header-top-nav">
      <div class="container">
        <div class="nav-container-top">
          <ul class="logged-in-nav" v-show="this.$store.state.isLoggedIn">
            <li class="no-underline cursor-default">
              Welcome, <span v-html="this.$store.state.firstName"></span>
            </li>
            <li @click="$router.push({ name: 'AccountDetail' }).catch(() => {})">
              My account
            </li>
            <li @click="$router.push({ name: 'OrderHistory' }).catch(() => {})">
              order history
            </li>
            <li @click="logout()">logout</li>
          </ul>
          <ul class="logged-out-nav" v-show="!this.$store.state.isLoggedIn">
            <li @click="$router.push({ name: 'LogIn' }).catch(() => {})">
              LOGIN
            </li>
            <li @click="$router.push({ name: 'SignUp' }).catch(() => {})">
              SIGN UP
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="header-row header-middle">
      <div class="container">
        <div class="nav-container-bottom">
          <ul :class="active">
            <li>
              <router-link class="nav-links" :to="{ name: 'About' }">
                About us
              </router-link>
            </li>
            <li v-show="$store.state.isLoggedIn">
              <router-link class="nav-links" :to="{ name: 'Curriculum' }">
                Curriculum & assets
              </router-link>
            </li>
            <li>
              <router-link class="nav-links" :to="{ name: 'Request' }">
                Request a kit
              </router-link>
            </li>
            <li>
              <router-link class="nav-links" :to="{ name: 'Contact' }">
                Contact us
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="header-row header-top">
      <div class="container">
        <h1 class="main-logo" @click="$router.push({ name: homePage }).catch(() => {})">
          <img src="@/assets/images/global/sun-hero-logo.png" alt=""/>
        </h1>
        <div class="mobile-menu-btn" @click="menuHandler()" :v-model="menuHandler">
          <i class="fas fa-bars"></i> MENU
        </div>
      </div>
    </div>
    <div class="mobile-nav"></div>
    <div class="mobile-nav-menu" v-show="showMobileMenu">
      <ul :class="active">
        <li class="no-underline" v-show="$store.state.isLoggedIn">
          Welcome, {{ $store.state.firstName }}
        </li>
        <li class="router-link-active" @click="
            activeId = 'login';
            activeButton('LogIn', activeId);
          " v-show="!$store.state.isLoggedIn">
          Log In
        </li>
        <li>
          <router-link class="nav-links" :to="{ name: 'About' }">
            About us <i class="fas fa-greater-than"></i></router-link>
        </li>
        <li>
          <router-link class="nav-links" :to="{ name: 'Contact' }">
            Contact us <i class="fas fa-greater-than"></i></router-link>
        </li>
        <li v-show="$store.state.isLoggedIn">
          <router-link class="nav-links" :to="{ name: 'Request' }">
            Request a kit <i class="fas fa-greater-than"></i></router-link>
        </li>
        <li v-show="$store.state.isLoggedIn">
          <router-link class="nav-links" :to="{ name: 'Curriculum' }">
            Curriculum & assets <i class="fas fa-greater-than"></i></router-link>
        </li>
        <li v-show="!$store.state.isLoggedIn">
          <router-link class="nav-links" :to="{ name: 'SignUp' }">
            Sign up <i class="fas fa-greater-than"></i></router-link>
        </li>
        <li v-show="$store.state.isLoggedIn">
          <router-link class="nav-links" :to="{ name: 'AccountDetail' }">
            My Account <i class="fas fa-greater-than"></i></router-link>
        </li>
        <li v-show="$store.state.isLoggedIn">
          <router-link class="nav-links" :to="{ name: 'OrderHistory' }">
            Order History <i class="fas fa-greater-than"></i></router-link>
        </li>
        <li @click="logout()" v-show="$store.state.isLoggedIn">Log out</li>
      </ul>
    </div>
  </header>
</template>
<script>
import { mapFields } from 'vuex-map-fields'

export default {
  created () {
    // window.addEventListener('resize', this.resize)
    // window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    // window.removeEventListener('resize', this.resize)
    // window.removeEventListener('scroll', this.handleScroll)
  },

  watch: {
    $route: 'currentRoute'
  },
  computed: {
    ...mapFields({
      open: 'navigationOpen'
    }),
    isKitPage () {
      return this.$route.name === 'RequestKit'
    }
  },
  data () {
    return {
      showMobileMenu: false,
      active: '',
      btnActive: 0,
      isActive: false,
      activeClass: '',
      mobileActiveClass: '',
      notActiveClass: '',
      routeName: null,
      activeId: '',
      activePage: '',
      homePage: 'Home'
    }
  },
  methods: {
    activeButton (page, id) {
      this.activePage = page
      this.active = id
      this.$store.state.currentPage = page
      if (this.active == this.$route.name) {
        this.activeClass = 'btn-active'
        this.mobileActiveClass = 'btn-mobile-active'
      }
      this.$router.push({ name: page }).catch(() => {})
    },
    currentRoute () {
      this.showMobileMenu = false
      this.activePage = this.$route.name
      // TODO: Change this to detect presence of JWT token
      if (this.$route.name == 'HomeLoggedIn') {
        this.$store.state.showLoggedInMenu = true
        this.$store.state.showLoggedOutMenu = false
        this.active = ''
        this.mobileActiveClass = ''
        this.homePage = 'HomeLoggedIn'
      } else if (this.$route.name == 'Home') {
        this.$store.state.showLoggedInMenu = false
        this.$store.state.showLoggedOutMenu = true
        this.homePage = 'Home'
        this.active = ''
        this.mobileActiveClass = ''
      } else if (
        this.$route.name == 'LogIn' ||
        (this.$route.name == 'SignUp' &&
          this.$store.state.isLoggedIn == true) ||
        (this.$route.name == 'SignUp' && this.$store.state.isLoggedIn == false)
      ) {
        this.active = ''
      }
    },

    menuHandler (e) {
      if (!this.showMobileMenu) {
        this.showMobileMenu = true
      } else {
        this.showMobileMenu = false
      }
    },
    openLink (e) {
      document.location = e
    },
    resize () {
      this.closeMenu()
    },
    handleScroll () {
      const scrollPos = window.scrollY
      if (scrollPos > 50) {
        document.querySelector('#header').classList.add('scroll')
      }
      if (scrollPos === 0) {
        document.querySelector('#header').classList.remove('scroll')
      }
    },
    clickMenuButton () {
      this.open = !this.open
    },
    openMenu () {
      this.open = true
    },
    closeMenu () {
      this.open = false
    },
    logout () {
      this.$store.commit('LOGOUT')
      delete this.axios.defaults.headers.common.Authorization
      this.$router.push({ name: 'Home' }).catch(() => {})
    }
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";

@keyframes Sheen {
  0% {
    background-position: 1% 50%;
  }
  10% {
    background-position: 99% 100%;
  }
  90% {
    background-position: 100% 0;
  }
  100% {
    background-position: 100% 0;
  }
}

header {
  // position: -webkit-sticky;
  // position: sticky;
  top: 0;
  font-size: 1rem;
  z-index: 99;
  background-color: @global-bg-color;

  .container {
    padding: 0 .clampedW(7, @md-bp, @large-bp) [ @result];
  }

  .mobile-nav {
    position: absolute;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;
    background-color: @color-dk-blue;
    height: 128px;
    display: none;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      display: block;
    }
  }

  .mobile-navigation {
    position: absolute;
    z-index: 9;
    top: 100%;
    left: 0;
    width: 100%;
    transform: translateY(-120%);
    transition: transform 0.2s;

    &.open {
      transform: translateY(0%);
    }
  }

  .header-row {
    position: relative;
    z-index: 14;
  }

  .header-top {
    .container {
      display: flex;
      align-items: center;
      transition: all 0.7s;

      .main-logo {
        cursor: pointer;
        position: absolute;
        left: 7%;
        top: 0%;
        transform: translate(-50%, -47%);
        color: #fff;
        font-family: @font-3;
        display: flex;
        align-items: center;
        padding: 1rem 0;
        @media screen and (max-width: ~"@{mq-md-bp}em") {
          left: 49%;
          transform: translate(-50%, 0%);
          z-index: 200;
        }

        img {
          //height: .clampedW(8, @md-bp, @large-bp)[@result];
          max-height: 100%;
          width: 18.6rem;
          @media screen and (max-width: ~"@{mq-md-bp}em") {
            width: 9.9rem;
          }
        }
      }
    }
  }

  &.scroll .header-top {
    .container {
      height: 15rem;
      transform: scale(0.75);
    }
  }

  .header-middle {
    background-color: @color-dk-blue;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      display: none;
    }

    .container {
      height: .clampedW(11, @md-bp, @large-bp) [ @result];
      // @media screen and (min-width: ~"@{mq-md-bp}em") {
      //   height: .clampedW(11, @md-bp, @large-bp) [ @result];
      // }
      display: flex;
      align-items: center;
      justify-content: flex-end;

      p {
        color: #fff;
        text-align: center;
        font-size: 1.7em;
        font-weight: 800;
      }

      .nav-container-bottom {
        ul {
          display: flex;
          flex-direction: row;
          // ul &.about,
          // ul &.cirriculum,
          // ul &.contact,
          // ul &.request {
          //   li {
          //     border-bottom: 5px solid orange;
          //   }
          // }
          &.about {
            li {
              // border-bottom: 5px solid orange;
            }
          }

          li {
            list-style: none;
            margin-top: 0;
            font-size: 1.5em;
            font-weight: 700;
            color: #ffffff;
            margin-right: 44px;
            cursor: pointer;
            // padding-bottom: 18px;
            // padding-top: 18px;
            // border-bottom: 5px solid transparent;
            // border-bottom: 5px solid transparent;
            // &:hover {
            //   border-bottom-color: @color-orange;
            //   // border-bottom: 5px solid @color-orange;
            // }
          }
        }
      }
    }
  }

  .btn-active {
    border-bottom: 5px solid @color-orange !important;
  }

  .btn-mobile-active {
    border: 2px solid #fff !important;
  }

  .btn-inactive {
    border-bottom: 5px solid transparent !important;
  }

  .logged-in-nav {
    ul {
      li {
        cursor: pointer;

        &:first-child {
          cursor: pointer;
        }
      }
    }
  }

  .logged-out-nav {
    ul {
      li {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .header-top-nav {
    background-color: @color-yellow;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      display: none;
    }

    .container {
      height: .clampedW(6, @md-bp, @large-bp) [ @result];
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      p {
        color: @color-txt-blue;
        text-align: center;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0;
      }

      .nav-container-top {
        display: flex;

        ul {
          display: flex;

          li {
            list-style: none;
            color: @color-txt-blue;
            margin-top: 0;
            font-weight: 700;
            font-size: 1.5em;
            margin-right: 44px;
            text-transform: uppercase;
            text-decoration: underline;
            cursor: pointer;

            &:first-child {
              text-transform: none;
            }
          }
        }
      }
    }
  }

  ul.about .about,
  ul.curriculum .curriculum,
  ul.request .request,
  ul.contact .contact {
    border-bottom: 5px solid @color-orange !important;
  }

  ul.about hr.about,
  ul.curriculum hr.curriculum,
  ul.request hr.request,
  ul.contact hr.contact,
  ul.signup hr.signup,
  ul.accountdetail hr.accountdetail,
  ul.orderhistory hr.orderhistory {
    border-bottom: none !important;
    border: 1px solid #fff !important;
  }

  ul.no-highlight .no-highlight {
    border-bottom: 5px solid transparent;
  }

  .header-bottom {
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    display: none;

    .container {
      padding: 0;
      display: flex;
      font-size: 1.4em;
      @media screen and (max-width: 400px) {
        font-size: 1.2em;
      }
    }
  }
}

.mobile-menu-btn {
  display: none;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  margin-top: 20px;
  cursor: pointer;

  .fa-bars {
    margin-right: 10px;
  }

  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: flex;
    justify-self: flex-end;
    margin-left: auto;
  }
}

.mobile-nav-menu {
  width: 100%;
  margin-top: 90px;
  background-color: @color-yellow;
  position: absolute;
  z-index: 15;

  &.router-link-active {
    border-bottom: 5px solid green !important;
  }

  @media screen and (min-width: 769px) {
    display: none;
  }

  ul {
    // width: 100%;
    li {
      font-weight: 700;
      font-size: 16px;
      color: @color-txt-blue;
      margin-top: 30px;
      margin-bottom: 30px;
      cursor: pointer;
      border-bottom: none !important;
      // hr {
      //   width: 100%;
      //   margin-left: -2%;
      //   border: 1px solid #fff;
      // }
      &:first-child {
        padding-top: 20px;
        cursor: default;
        font-size: 18px;
      }

      &:last-child {
        padding-bottom: 20px;
      }

      .fa-greater-than {
        float: right;
        margin-right: 30px;
      }
    }
  }

  hr.about,
  hr.contact,
  hr.curriculum,
  hr.signup,
  hr.request,
  hr.accountdetail,
  hr.orderhistory {
    border: 1px solid transparent !important;
    width: 95%;
    margin-left: -1%;
  }
}

@media screen and (max-width: ~"@{mq-md-bp}em") {
  header {
    .container {
      padding: 0 2vw;
    }

    .header-middle {
      border: none;

      .container {
        padding: 0 2vw;
        justify-content: center;

        .brand-logo {
          margin: 0;
        }
      }
    }

    .header-bottom {
      display: block;
    }
  }
}

&.router-link-active {
  border-bottom: 5px solid @color-orange !important;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    border-bottom: 2px solid #fff !important;
  }
  // &:hover {
  //   border-bottom-color: @color-orange;
  //   // border-bottom: 5px solid @color-orange;
  // }

  // &:after {
  //   content: "";
  //   position: absolute;
  //   bottom: 0;
  //   width: 100%;
  //   left: 0;
  //   height: 6px;
  //   background-color: @color-beige;
  // }
}

.transparent-underline {
  border-bottom: 5px solid transparent;
}

.nav-links {
  font-family: @open-sans-font;
  font-weight: 700;
  // font-size: 14px;
  color: #fff;
  padding-bottom: 18px;
  @media screen and (max-width: 768px) {
    padding-bottom: 9px !important;
  }
  @media screen and (max-width: 900px) {
    padding-bottom: 11px;
  }
  @media screen and (min-width: 1200px) {
    padding-bottom: 20px;
  }
  // border-bottom-color: @color-orange;
  border-bottom: 5px solid transparent;
  // padding-top: 7px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    color: @color-txt-blue;
    padding-right: 43%;
  }

  &:hover {
    border-bottom: 5px solid @color-orange !important;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      border-bottom: 2px solid transparent !important;
    }
  }
}
</style>
